import { useCallback, useState } from "react";
import { postMethodCustomHeader } from "../../../utils/response";

export const useEmailValidation = () => {
  const [isValid, setIsValid] = useState(null);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = useCallback(async (email) => {
    // Clear previous state
    setIsValid(null);
    setMessage("");

    // Check if email is empty
    if (!email || email.trim() === "") {
      setIsValid(false);
      setMessage("Email is required");
      return;
    }

    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setIsValid(false);
      setMessage("Invalid email format");
      return;
    }

    // Server validation
    setIsLoading(true);
    try {
      const response = await postMethodCustomHeader("validate-email", {
        email,
      });

      if (response.data.success) {
        setIsValid(true);
        setMessage(response.data.message || "Email is valid");
      } else {
        setIsValid(false);
        setMessage(response.data.message || "Email validation failed");
      }
    } catch (error) {
      setIsValid(false);
      setMessage(
        error?.response?.data?.message || "Email validation service unavailable"
      );
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearValidation = useCallback(() => {
    setIsValid(null);
    setMessage("");
    setIsLoading(false);
  }, []);

  return {
    isValid,
    message,
    isLoading,
    validateEmail,
    clearValidation,
  };
};
